import { render, staticRenderFns } from "./BoxDetail.vue?vue&type=template&id=5c978173&scoped=true&"
import script from "./BoxDetail.vue?vue&type=script&lang=js&"
export * from "./BoxDetail.vue?vue&type=script&lang=js&"
import style0 from "./BoxDetail.vue?vue&type=style&index=0&id=5c978173&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c978173",
  null
  
)

export default component.exports